//@flow
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import React from 'react';
import Grid from '@mui/material/Grid2';
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import LinkIcon from "../../../assets/images/icons/general/linkIcon";
import {showNoValueIfDisabled} from "./catalog";
import {FormHelperText} from "@mui/material";
import {ErrorMessage} from "formik";
import Typography from "@mui/material/Typography";

const CatalogBrands = ({formik, inputVariant, disabled}) => {
    return (
        <Grid container spacing={1.5}>
            <Grid size={12}>
                <ListItem sx={{ p: 0 }}>
                    <ListItemText>
                        <Typography
                            variant="bodyMedium"
                            component={"div"}
                            sx={{
                                color: '#5E666B',
                                fontWeight: 'bold',
                                fontSize: '15px'
                            }}
                        >
                            BRANDS
                        </Typography>
                    </ListItemText>
                </ListItem>
                <Divider sx={{ mb: '2rem', border: '1px solid #5E666B' }}/>
            </Grid>
            {[...Array(10).keys()].map(index => (
                <Grid size={{xs: 12, md: 6}} key={index}>
                    <FormControl
                        variant="standard"
                        color={'error'}
                        fullWidth
                        error={
                            formik.touched[`brands${index}`] &&
                            Boolean(formik.errors[`brands${index}`])
                        }
                    >
                        <TextField
                            disabled={disabled}
                            variant={inputVariant}
                            label={`Brand-${index + 1}`}
                            type={'text'}
                            size={"small"}
                            name={`brands${index}`}
                            value={showNoValueIfDisabled(formik.values[`brands${index}`], disabled)}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            fullWidth
                            slotProps={{
                                htmlInput: {
                                   maxLength: 250
                                },
                            }}
                        />
                        <FormHelperText sx={{color: '#d32f2f'}}>
                            <ErrorMessage name={`brands${index}`}/>
                        </FormHelperText>
                    </FormControl>
                </Grid>
            ))}
        </Grid>
    )
}

export default CatalogBrands
